import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken, requestUserProfile } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaSettingTypes } from './sagaSettingRedux';
import { getCurrentUserId } from '../../helpers/utility';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import SagaAuthActions from '../sagaAuth/sagaAuthRedux';

export function* requestUpdatePropAndProjectSettings(action) {
    const tag = '[REQUEST_UPDATE_PROP_AND_PROJECT_SETTINGS]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePropAndProjectSettings, jwtToken, branchId, culture, action.propAndProjectSettingUpdate);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropAndProjectSettings response :`, response.data);
                yield put(Actions.updatePropAndProjectSettingsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropAndProjectSettings failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropAndProjectSettingsFailure(message));
    }
}

export function* requestGetSalesCommissionSetting(action) {
    const tag = '[REQUEST_GET_SALES_COMMISSION_SETTING]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetSalesCommissionSettings, jwtToken, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetSalesCommissionSettings response :`, response.data.result);
                yield put(Actions.getSalesCommissionSettingSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetSalesCommissionSetting failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getSalesCommissionSettingFailure(message));
    }
}

export function* requestUpdateSalesCommissionSetting(action) {
    const tag = '[REQUEST_UPDATE_SALES_COMMISSION_SETTING]';
    console.log('action', action);
    try {
        // step 1: perform input validation
        const inputValid = true; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateSalesCommissionSetting, jwtToken, branchId, action.salesCommissiontSettingUpdate.userId, culture, action.salesCommissiontSettingUpdate.items);
            console.log(`${tag} requestUpdateSalesCommissionSetting response :`, response);
            if (response.status === 200 && response.data.statusCode === 200) {
                if ((response.data.result) && response.data.result.length > 0) {
                    yield put(Actions.updateSalesCommissionFailure(response.data.result));
                } else {
                    yield put(Actions.updateSalesCommissionSuccess(response.data.result));
                    // yield put(Actions.requestGetSalesCommissionSetting());
                }
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateSalesCommissionSetting failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateSalesCommissionFailure(message));
    }
}

export function* requestGetAllPropAndProjectSettings(action) {
    const tag = '[REQUEST_GET_ALL_PROP_AND_PROJECT_SETTINGS]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            // step 2 : validation passed..
            const response = yield call(API.requestGetAllPropAndProjectSettings, jwtToken, branchId, culture, action.settingCommon);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetAllPropAndProjectSettings response :`, response.data);
                yield put(Actions.getAllPropAndProjectSettingsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetAllPropAndProjectSettings failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getAllPropAndProjectSettingsFailure(message));
    }
}

export function* requestUpdateDropdownOptionSettings(action) {
    const tag = '[REQUEST_UPDATE_DROPDOWN_OPTION_SETTINGS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateDropdownOptionSettings, jwtToken, branchId, culture, action.dropdownSettingUpdate);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDropdownOptionSettings response :`, response.data);
                yield put(Actions.updateDropdownOptionSettingsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateDropdownOptionSettings failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDropdownOptionSettingsFailure(message));
    }
}

export function* requestGetEnquirySettings(action) {
    const tag = '[REQUEST_GET_ENQUIRY_SETTINGS]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetEnquirySettings, jwtToken, branchId, culture, action.settingCommon);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEnquirySettings response :`, response.data);
                yield put(Actions.getEnquirySettingsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEnquirySettings failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEnquirySettingsFailure(message));
    }
}

export function* requestUpdateDocumentTemplate(action) {
    const tag = '[REQUEST_UPDATE_DOCUMENT_TEMPLATE]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateDocumentTemplate, jwtToken, branchId, culture, action.documentTemplateUpdate);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDocumentTemplate response :`, response.data);
                yield put(Actions.updateDocumentTemplateSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateDocumentTemplate failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDocumentTemplateFailure(message));
    }
}

export function* requestGetMultiLanguage() {
    const tag = '[REQUEST_GET_MULTI_LANGUAGE]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetMultiLanguage, jwtToken, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetMultiLanguage response :`, response.data);
                yield put(Actions.getMultiLanguageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetMultiLanguage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getMultiLanguageFailure(message));
    }
}

export function* requestGetOfficeSettingLanguage() {
    const tag = '[REQUEST_GET_OFFICE_SETTING_LANGUAGE]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetOfficeSettingLanguage, jwtToken, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetOfficeSettingLanguage response :`, response.data);
                yield put(Actions.getOfficeSettingLanguageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetOfficeSettingLanguage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getOfficeSettingLanguageFailure(message));
    }
}

export function* requestUpdateDefaultOfficeLanguage(action) {
    const tag = '[REQUEST_UPDATE_DEFAULT_OFFICE_LANGUAGE]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateDefaultOfficeLanguage, jwtToken, branchId, culture, action.id);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDefaultOfficeLanguage response :`, response.data);
                yield put(Actions.updateDefaultOfficeLanguageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateDefaultOfficeLanguage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDefaultOfficeLanguageFailure(message));
    }
}

export function* requestDeleteLanguageOfficeMapping(action) {
    const tag = '[REQUEST_DELETE_LANGUAGE_OFFICE_MAPPING]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestDeleteLanguageOfficeMapping, jwtToken, branchId, action.langId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteLanguageOfficeMapping response :`, response.data);
                yield put(Actions.deleteLanguageOfficeMappingSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/branchId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteLanguageOfficeMapping failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteLanguageOfficeMappingFailure(message));
    }
}

export function* requestCreateLanguageOfficeMapping(action) {
    const tag = '[REQUEST_CREATE_LANGUAGE_OFFICE_MAPPING]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestCreateLanguageOfficeMapping, jwtToken, branchId, action.langId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestCreateLanguageOfficeMapping response :`, response.data);
                yield put(Actions.createLanguageOfficeMappingSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateLanguageOfficeMapping failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createLanguageOfficeMappingFailure(message));
    }
}

export function* requestGetDefaultOfficeSettingLanguage(action) {
    const tag = '[REQUEST_GET_DEFAULT_OFFICE_SETTING_LANGUAGE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetDefaultOfficeSettingLanguage, jwtToken, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetDefaultOfficeSettingLanguage response :`, response.data);
                yield put(Actions.getDefaultOfficeSettingLanguageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetDefaultOfficeSettingLanguage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getDefaultOfficeSettingLanguageFailure(message));
    }
}

export function* requestGetOfficeSettings(action) {
    const tag = '[REQUEST_GET_OFFICE_SETTINGS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetOfficeSettings, jwtToken, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetOfficeSettings response :`, response.data);
                yield put(Actions.getOfficeSettingsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Invalid parameters.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetOfficeSettings failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getOfficeSettingsFailure(message));
    }
}

export function* requestUpdateOfficeDetail(action) {
    const tag = '[REQUEST_UPDATE_OFFICE_DETAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfficeDetail, jwtToken, branchId, culture, action.officeDetail);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfficeDetail response :`, response.data);
                yield put(Actions.updateOfficeDetailSuccess(response.data.result));
                yield put(SagaAuthActions.updateGlobalSetting(response.data.result));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfficeDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfficeDetailFailure(message));
    }
}

export function* requestUpdateOfficeBuyerCosts(action) {
    const tag = '[REQUEST_UPDATE_OFFICE_BUYER_COSTS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfficeBuyerCosts, jwtToken, branchId, culture, action.officeDetail);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfficeBuyerCosts response :`, response.data);
                yield put(Actions.updateOfficeBuyerCostsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfficeBuyerCosts failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfficeBuyerCostsFailure(message));
    }
}

export function* requestUpdateOfficeFMR(action) {
    const tag = '[REQUEST_UPDATE_OFFICE_F_M_R]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfficeFMR, jwtToken, branchId, culture, action.officeDetail);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfficeFMR response :`, response.data);
                yield put(Actions.updateOfficeFMRSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfficeFMR failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfficeFMRFailure(message));
    }
}

export function* requestUpdateOfficePortal(action) {
    const tag = '[REQUEST_UPDATE_OFFICE_PORTAL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfficePortal, jwtToken, branchId, culture, action.officePortal);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfficePortal response :`, response.data);
                yield put(Actions.updateOfficePortalSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfficePortal failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfficePortalFailure(message));
    }
}

export function* requestDeleteOfficePortal(action) {
    const tag = '[REQUEST_DELETE_OFFICE_PORTAL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestDeleteOfficePortal, jwtToken, branchId, culture, action.portalSenderId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteOfficePortal response :`, response.data);
                yield put(Actions.deleteOfficePortalSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteOfficePortal failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteOfficePortalFailure(message));
    }
}

export function* requestCreateOfficePortal(action) {
    const tag = '[REQUEST_CREATE_OFFICE_PORTAL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestCreateOfficePortal, jwtToken, branchId, culture, action.portalSender);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestCreateOfficePortal response :`, response.data);
                yield put(Actions.createOfficePortalSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateOfficePortal failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createOfficePortalFailure(message));
    }
}

export function* requestUpdateOfficeDarkpool(action) {
    const tag = '[REQUEST_UPDATE_OFFICE_DARKPOOL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOfficeDarkpool, jwtToken, branchId, culture, action.officeDetail);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOfficeDarkpool response :`, response.data);
                yield put(Actions.updateOfficeDarkpoolSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOfficeDarkpool failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOfficeDarkpoolFailure(message));
    }
}

export function* requestGetEmployees(action) {
    const tag = '[REQUEST_GET_EMPLOYEES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            const response = yield call(API.requestGetEmployees, jwtToken, branchId, userId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEmployees response :`, response.data);
                yield put(Actions.getEmployeesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEmployees failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEmployeesFailure(message));
    }
}

export function* requestGetEmployeeDetail(action) {
    const tag = '[REQUEST_GET_EMPLOYEE_DETAIL]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            const response = yield call(API.requestGetEmployeeDetail, jwtToken, branchId, action.userId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEmployeeDetail response :`, response.data);
                yield put(Actions.getEmployeeDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEmployeeDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEmployeeDetailFailure(message));
    }
}

export function* requestSaveEmployeeDetail(action) {
    const tag = '[REQUEST_SAVE_EMPLOYEE_DETAIL]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            const response = yield call(API.requestSaveEmployeeDetail, jwtToken, action.employeeDetail, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSaveEmployeeDetail response :`, response.data);
                yield put(Actions.saveEmployeeDetailSuccess(response.data.result));
                yield requestUserProfile(jwtToken);
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSaveEmployeeDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.saveEmployeeDetailFailure(message));
    }
}

export function* requestSaveEmployeeEducationDetail(action) {
    const tag = '[REQUEST_SAVE_EMPLOYEE_EDUCATION_DETAIL]';
    try {
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            const response = yield call(API.requestSaveEmployeeEducationDetail, jwtToken, action.usersEducations);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSaveEmployeeEducationDetail response :`, response.data);
                yield put(Actions.saveEmployeeEducationDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSaveEmployeeEducationDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.saveEmployeeEducationDetailFailure(message));
    }
}

export function* requestUpdatePropertiesOnWeb(action) {
    const tag = '[REQUEST_UPDATE_PROPERTIES_ON_WEB]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            const response = yield call(API.requestUpdatePropertiesOnWeb, jwtToken, branchId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertiesOnWeb response :`, response.data);
                yield put(Actions.updatePropertiesOnWebSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertiesOnWeb failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertiesOnWebFailure(message));
    }
}

export function* requestAutoGenerateUserName() {
    const tag = '[REQUEST_AUTO_GENERATE_USER_NAME]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            const response = yield call(API.requestAutoGenerateUserName, jwtToken, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestAutoGenerateUserName response :`, response.data);
                yield put(Actions.autoGenerateUserNameSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestAutoGenerateUserName failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.autoGenerateUserNameFailure(message));
    }
}

export function* requestUpdateEmployeeStatus(action) {
    const tag = '[REQUEST_UPDATE_EMPLOYEE_STATUS]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            const response = yield call(API.requestUpdateEmployeeStatus, jwtToken, action.employeeStatus, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateEmployeeStatus response :`, response.data);
                yield put(Actions.updateEmployeeStatusSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateEmployeeStatus failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateEmployeeStatusFailure(message));
    }
}

export function* requestGetEmployeeStatusProperties(action) {
    const tag = '[REQUEST_GET_EMPLOYEE_STATUS_PROPERTIES]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            const response = yield call(API.requestGetEmployeeStatusProperties, jwtToken, branchId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEmployeeStatusProperties response :`, response.data);
                yield put(Actions.getEmployeeStatusPropertiesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEmployeeStatusProperties failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEmployeeStatusPropertiesFailure(message));
    }
}

export function* requestSaveUserColumnSetting(action) {
    const tag = '[REQUEST_SAVE_USER_COLUMN_SETTING]';
    try {
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestSaveUserColumnSetting, jwtToken, action.userId, action.settingType, action.selectedColumns);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSaveUserColumnSetting response :`, response.data);
                yield put(Actions.saveUserColumnSettingSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSaveUserColumnSetting failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.saveUserColumnSettingFailure(message));
    }
}

export function* requestUpdateUserDefaultList(action) {
    const tag = '[REQUEST_UPDATE_USER_DEFAULT_LIST]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateUserDefaultList, jwtToken, action.userId, action.defaultList);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateUserDefaultList response :`, response.data);
                yield put(Actions.updateUserDefaultListSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateUserDefaultList failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateUserDefaultListFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(SagaSettingTypes.REQUEST_GET_SALES_COMMISSION_SETTING, requestGetSalesCommissionSetting),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_SALES_COMMISSION_SETTING, requestUpdateSalesCommissionSetting),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_PROP_AND_PROJECT_SETTINGS, requestUpdatePropAndProjectSettings),
        takeLatest(SagaSettingTypes.REQUEST_GET_ALL_PROP_AND_PROJECT_SETTINGS, requestGetAllPropAndProjectSettings),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_DROPDOWN_OPTION_SETTINGS, requestUpdateDropdownOptionSettings),
        takeLatest(SagaSettingTypes.REQUEST_GET_ENQUIRY_SETTINGS, requestGetEnquirySettings),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_DOCUMENT_TEMPLATE, requestUpdateDocumentTemplate),
        takeLatest(SagaSettingTypes.REQUEST_GET_MULTI_LANGUAGE, requestGetMultiLanguage),
        takeLatest(SagaSettingTypes.REQUEST_GET_OFFICE_SETTING_LANGUAGE, requestGetOfficeSettingLanguage),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_DEFAULT_OFFICE_LANGUAGE, requestUpdateDefaultOfficeLanguage),
        takeLatest(SagaSettingTypes.REQUEST_DELETE_LANGUAGE_OFFICE_MAPPING, requestDeleteLanguageOfficeMapping),
        takeLatest(SagaSettingTypes.REQUEST_CREATE_LANGUAGE_OFFICE_MAPPING, requestCreateLanguageOfficeMapping),
        takeLatest(SagaSettingTypes.REQUEST_GET_DEFAULT_OFFICE_SETTING_LANGUAGE, requestGetDefaultOfficeSettingLanguage),
        takeLatest(SagaSettingTypes.REQUEST_GET_OFFICE_SETTINGS, requestGetOfficeSettings),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_OFFICE_DETAIL, requestUpdateOfficeDetail),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_OFFICE_BUYER_COSTS, requestUpdateOfficeBuyerCosts),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_OFFICE_F_M_R, requestUpdateOfficeFMR),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_OFFICE_PORTAL, requestUpdateOfficePortal),
        takeLatest(SagaSettingTypes.REQUEST_DELETE_OFFICE_PORTAL, requestDeleteOfficePortal),
        takeLatest(SagaSettingTypes.REQUEST_CREATE_OFFICE_PORTAL, requestCreateOfficePortal),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_OFFICE_DARKPOOL, requestUpdateOfficeDarkpool),
        takeLatest(SagaSettingTypes.REQUEST_GET_EMPLOYEES, requestGetEmployees),
        takeLatest(SagaSettingTypes.REQUEST_GET_EMPLOYEE_DETAIL, requestGetEmployeeDetail),
        takeLatest(SagaSettingTypes.REQUEST_SAVE_EMPLOYEE_DETAIL, requestSaveEmployeeDetail),
        takeLatest(SagaSettingTypes.REQUEST_SAVE_EMPLOYEE_EDUCATION_DETAIL, requestSaveEmployeeEducationDetail),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_PROPERTIES_ON_WEB, requestUpdatePropertiesOnWeb),
        takeLatest(SagaSettingTypes.REQUEST_AUTO_GENERATE_USER_NAME, requestAutoGenerateUserName),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_EMPLOYEE_STATUS, requestUpdateEmployeeStatus),
        takeLatest(SagaSettingTypes.REQUEST_GET_EMPLOYEE_STATUS_PROPERTIES, requestGetEmployeeStatusProperties),
        takeLatest(SagaSettingTypes.REQUEST_SAVE_USER_COLUMN_SETTING, requestSaveUserColumnSetting),
        takeLatest(SagaSettingTypes.REQUEST_UPDATE_USER_DEFAULT_LIST, requestUpdateUserDefaultList),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagaSetting/sagaSettingSaga.ts